import keys from '@debbie/common/dist/cache/keys.js';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { VoucherApplicationType, VoucherApplicationTarget, InterestFrom, } from '@debbie/common/dist/voucher-applications/index.js';
import * as voucherApplications from '@debbie/cortex/dist/api/voucher-applications.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { creditorsEntity } from '@debbie/cortex/dist/creditors/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import { voucherApplicationsEntity } from '@debbie/cortex/dist/voucher-applications/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../Button.js';
import CreditorSelect from '../CreditorSelect.js';
import Messages from '../Messages/index.js';
import SentenceSelect from '../SentenceSelect.js';
import VoucherCustomizer from './VoucherCustomizer.js';
const CreateVoucherApplication = (props) => {
    const filterCategories = props.filters?.targetCategory || ((c) => true);
    const filterTypes = props.filters?.targetType || ((c) => true);
    const filterCreateType = props.filters?.type || ((c) => true);
    const lang = useSelector((s) => s.lang);
    const authToken = useSelector(selectAuthToken);
    const tenantId = useTenantId();
    const [type, setType] = useState(VoucherApplicationType.VoucherType);
    const [target, setTarget] = useState(VoucherApplicationTarget.Both);
    const [voucherType, setVoucherType] = useState(VoucherTypeIds.PROCESSINTEREST);
    const [applyToVoucherType, setApplyToVoucherType] = useState(VoucherTypeIds.INVOICE);
    const [applyToVoucherCategory, setApplyToVoucherCategory] = useState(VoucherCategory.PRINCIPAL);
    const [voucherOptions, setVoucherOptions] = useState({ days: 30, from: InterestFrom.Date });
    const [creditorId, setCreditorId] = useState(null);
    const [creating, setCreating] = useState(false);
    const [error, setError] = useState(null);
    const createVoucherApplication = async () => {
        setCreating(true);
        try {
            const voucherApplication = {
                type,
                target,
                voucherType,
            };
            if (type === VoucherApplicationType.VoucherType) {
                voucherApplication.applyToVoucherType = applyToVoucherType;
            }
            else if (type === VoucherApplicationType.VoucherCategory) {
                voucherApplication.applyToVoucherCategory = applyToVoucherCategory;
            }
            voucherApplication.voucherOptions = voucherOptions;
            const application = voucherApplication;
            if (authToken != null && tenantId != null) {
                await voucherApplications.create({
                    application,
                    creditorId: creditorId ?? undefined,
                });
                q.invalidate(keys.write.create(voucherApplicationsEntity));
                if (creditorId != null) {
                    q.invalidate(keys.write.modify(creditorsEntity, creditorId));
                }
            }
            props.onClose();
        }
        catch (e) {
            console.error(e);
            setError(lang.voucherApplications.createError);
        }
        setCreating(false);
    };
    return (React.createElement(React.Fragment, null,
        error != null && React.createElement(Messages, { type: "error", messages: [error] }),
        React.createElement(SentenceSelect, { values: {
                type: type,
                target: target,
                applyToType: applyToVoucherType,
                applyToCategory: applyToVoucherCategory,
            }, options: {
                type: Object.values(VoucherApplicationType).map((v) => ({
                    value: v,
                    label: lang.voucherApplicationTypeLabels[v],
                })),
                target: Object.values(VoucherApplicationTarget).map((v) => ({
                    value: v,
                    label: lang.voucherApplicationTargetLabels[v],
                })),
                applyToType: Object.values(VoucherTypeIds)
                    .filter(filterTypes)
                    .map((v) => ({
                    value: v,
                    label: lang.economyVoucherTypeLabels[v],
                })),
                applyToCategory: Object.values(VoucherCategory)
                    .filter(filterCategories)
                    .map((v) => ({
                    value: v,
                    label: lang.economyCategories[v],
                })),
            }, sentenceBuilder: (s) => {
                const third = s.type === VoucherApplicationType.VoucherType
                    ? { value: 'applyToType' }
                    : s.type === VoucherApplicationType.Case
                        ? ''
                        : { value: 'applyToCategory' };
                return [
                    lang.voucherApplications.textSelector1,
                    { value: 'type' },
                    ' ',
                    third,
                    lang.voucherApplications.textSelector2,
                    { value: 'target' },
                    lang.voucherApplications.textSelector3,
                ];
            }, onChange: (v) => {
                if (v.type) {
                    setType(v.type);
                }
                if (v.target) {
                    setTarget(v.target);
                }
                if (v.applyToType) {
                    setApplyToVoucherType(v.applyToType);
                }
                if (v.applyToCategory) {
                    setApplyToVoucherCategory(v.applyToCategory);
                }
            } }),
        React.createElement(VoucherCustomizer, { style: {
                marginTop: '20px',
                marginLeft: '-20px',
                marginRight: '-20px',
                marginBottom: '20px',
                width: 'calc(100% + 40px)',
            }, voucherType: voucherType, onChange: (vt, vo) => {
                setVoucherType(vt);
                setVoucherOptions(vo);
            }, filter: filterCreateType }),
        React.createElement("p", { style: { marginBottom: '.5em' } }, lang.voucherApplications.forCreditor),
        React.createElement(CreditorSelect, { value: creditorId, onChange: setCreditorId }),
        React.createElement("div", { style: { textAlign: 'right' } },
            React.createElement(Button, { disabled: creating, theme: "secondary", style: { marginRight: '0.5rem' }, onClick: () => {
                    props.onClose();
                } }, lang.misc.cancel),
            React.createElement(Button, { disabled: creating, onClick: createVoucherApplication }, lang.misc.add))));
};
export default CreateVoucherApplication;
//# sourceMappingURL=CreateVoucherApplication.js.map